import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
let currentTheme = 'light';

export default {
    install(Vue) {
        Vue.use(VueFlatPickr);

        Vue.prototype.$setFlatpickrTheme = (dark) => {
            const newTheme = dark ? 'dark' : 'light';

            // Evitar cambios innecesarios
            if (currentTheme === newTheme) return;

            // Buscar el `<link>` del tema
            let link = document.getElementById('flatpickr-theme');
            if (!link) {
                // Si no existe, lo creamos
                link = document.createElement('link');
                link.id = 'flatpickr-theme';
                link.rel = 'stylesheet';
                document.head.appendChild(link);
            }

            // Actualizar la URL del CDN
            // link.href = dark
            //     ? 'https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/dark.css'
            //     : 'https://cdn.jsdelivr.net/npm/flatpickr/dist/themes/light.css';

            // // Cambiar clases en los calendarios existentes
            // document.querySelectorAll('.flatpickr-calendar').forEach(el => {
            //     el.classList.remove('dark', 'light');
            //     el.classList.add(newTheme);
            // });

            // currentTheme = newTheme;
        };

        Vue.prototype.$getCurrentFlatpickrTheme = () => currentTheme;
    }
};
